import React, { useState, useRef, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import Webcam from "react-webcam";
import { toast } from "react-toastify";

import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
    InputGroup,
    Table,

} from "reactstrap";
import { addVision } from "service/api";


const defaultValue = {
    vision: "",
}
document.title = "Vision | optom";

const Vision = () => {
    const [vision, setAddData] = useState(defaultValue);

    const onValueChange = e => {
        setAddData({ ...vision, [e.target.name]: e.target.value });
    };
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        await addVision(vision);
        console.log(vision);
        navigate("/Vision_type");
        toast.success("User saved successfully.", {
            position: "top-center",
            autoClose: 2000,
        })
    }



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        {/* <CardTitle className="mb-4">ADD Patient</CardTitle> */}
                        <h4 className="page-title">Add Vision</h4>
                        <Link to="/Vision_list" className="btn btn-danger">List</Link>
                    </div>
                    <Row>
                        <Card>
                            <CardBody>
                                <Form>
                                    <Row>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Vision</Label>
                                                <Input type="text" className="form-control" name="vision" placeholder="vision" onChange={(e) => onValueChange(e)} />
                                            </div>
                                        </Col>
                                    </Row>
                                    <div>
                                        <button className="btn btn-primary w-md mx-2" onClick={(e) => handleSubmit(e)}>
                                            Save
                                        </button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
        </React.Fragment >
    )
}


export default Vision
